<template>
  <div
    :style="styles"
    class="rt-detail-aside"
  >
    <slot />
    <rt-button-more
      v-if="showMore"
      class="rt-detail-more"
      expanded-suffix-icon="rt-base-arrow-up-lined"
      collapsed-suffix-icon="rt-base-arrow-down-lined"
      @change="_changeExpand"
    ></rt-button-more>

    <!-- <div v-if="showMore" class="rt-detail-more">
      <div v-if="packUp" class="more-item" @click="packUpItems">
        <p>{{ $tx('收起全部', 'xpc.business.detailaside.up') }}</p>
        <rt-icon name="rt-base-arrow-up-lined"></rt-icon>
      </div>
      <div v-else class="more-item" @click="rollUpItems">
        <p>{{ $tx('展开更多', 'xpc.business.detailaside.more') }}</p>
        <rt-icon name="rt-base-arrow-down-lined"></rt-icon>
      </div>
    </div> -->
  </div>
</template>

<script>
import RtButtonMore from '../../button/rtButtonMore.vue';

export default {
  name: 'RtDetailAside',
  components: { RtButtonMore },
  props: {
    showMore: {
      type: Boolean,
      default: false
    },
    maxItems: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      packUp: false,
      items: [],
      movedItems: [],
      moved: false
    };
  },
  computed: {
    styles () {
      return {
        paddingBottom: this.showMore ? '40px' : '20px'
      };
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.items = this.$slots.default.filter(item => {
        return item.tag;
      });
      if (this.items.length > this.maxItems) {
        this.removeItems();
      }
    },
    removeItems () {
      let movedItems = [];
      this.items.forEach((item, index) => {
        if (index >= this.maxItems) {
          movedItems.push(item.elm);
          this.$el.removeChild(item.elm);
        }
      });
      this.movedItems = movedItems.slice();
      this.packUp = false;
    },

    /**
     * @private
     */
    _changeExpand (isExpand) {
      if (isExpand) {
        this.rollUpItems();
      } else {
        this.packUpItems();
      }
    },

    packUpItems () {
      this.init();
    },
    rollUpItems () {
      this.movedItems.forEach(item => {
        this.$el.appendChild(item);
      });
      this.packUp = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailAside.vue?79098900